import { useCallback, useEffect } from 'react';
import {
    VIDEO_CALL_INDEX,
    VIDEO_CALL_URL,
    VIDEO_SELFIE_INDEX,
    VIDEO_SELFIE_URL,
} from 'components/newIdentifyMethods/video/constants';
import { CREDIT_CARD, ROBO, ROBO_REJECTED, TRADITIONAL } from 'constants/userProfile';
import { ROBO_VIDEOSELFIE, TC_VIDEOSELFIE, VIDEOSELFIE } from 'constants/featureFlagging';
import { VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';

export const useUpdateUserProfileOnVideoOptionChange = ({
    flags,
    withTabs,
    type,
    videoSelected,
    investmentType,
    change,
    resetValidity,
}) => {
    const getType = useCallback(() => {
        if (!withTabs) return type;
        const investmentsTypesForVideos = {
            [CREDIT_CARD]: flags?.get(TC_VIDEOSELFIE),
            [ROBO]: flags?.get(ROBO_VIDEOSELFIE),
            [ROBO_REJECTED]: flags?.get(VIDEOSELFIE),
            [TRADITIONAL]: flags?.get(VIDEOSELFIE),
        };

        return investmentsTypesForVideos[investmentType] ? VIDEO_SELFIE : VIDEO_CALL;
    }, [flags, withTabs, investmentType, type]);

    const updateUserProfileWithOptionType = useCallback(type => {
        const isVideoCallType = type === VIDEO_CALL;
        change('userProfile.selectedItemIndex', isVideoCallType ? VIDEO_CALL_INDEX : VIDEO_SELFIE_INDEX);
        change('userProfile.videoSelected', type);
        change('userProfile.videoUrlSelected', isVideoCallType ? VIDEO_CALL_URL : VIDEO_SELFIE_URL);
    }, []);

    const clearUserProfileOption = useCallback(type => {
        const isVideoCallType = type === VIDEO_CALL;
        resetValidity('userProfile.agreeVideoCallClauseCheck');
        resetValidity('userProfile.videoCallClause');
        change('userProfile.selectedItemIndex', isVideoCallType ? VIDEO_CALL_INDEX : VIDEO_SELFIE_INDEX);
        change('userProfile.videoSelected', '');
        change('userProfile.videoUrlSelected', '');
    }, []);

    useEffect(() => {
        const type = getType();
        if (type !== videoSelected) updateUserProfileWithOptionType(type);
    }, [getType, videoSelected, updateUserProfileWithOptionType]);

    useEffect(() => {
        const type = getType();

        return () => {
            clearUserProfileOption(type);
        };
    }, [getType, updateUserProfileWithOptionType, clearUserProfileOption]);
};
